import React, { useMemo } from 'react';
import EvaluationDropZone from '../../DropZones/EvaluationDropZone';
import { useSelector } from 'react-redux';
import '../../../../index.css';
import { Divider, Typography } from '@mui/material';
import EvaluationCard from './EvaluationCard';
import { fontSize } from '../../../..';
import { isFlowUsed } from '../../utils';
import { RootState } from '../../../../redux';

const Evaluations = () => {
  const { propKey, calculations } = useSelector((state: RootState) => ({
    propKey:
      state.tabTileProps.selectedTabId.toString() +
      '.' +
      state.tabTileProps.selectedTileId.toString(),
    calculations: state.calculations,
  }));

  const currentCalculationSession = calculations.properties[propKey]?.currentCalculationSession;

  const disableUpdate = useMemo(() => {
    if (!currentCalculationSession) return true;
    return isFlowUsed(
      Object.keys(currentCalculationSession.calculationInfo.flows),
      currentCalculationSession.calculationInfo.flows,
      currentCalculationSession.activeFlow!,
      currentCalculationSession.calculationInfo,
    );
  }, [currentCalculationSession]);

  if (
    !currentCalculationSession ||
    !currentCalculationSession.activeFlow ||
    currentCalculationSession.activeCondition === null
  )
    return null;
  // const activeCondition = currentCalculationSession.activeCondition;

  const activeFlow = currentCalculationSession.activeFlow;
  const activeConditonIndex = currentCalculationSession.activeCondition;

  const conditionTypeElse =
    currentCalculationSession.calculationInfo.flows[activeFlow][activeConditonIndex ?? 0]
      ?.condition === 'else';
  const filterName =
    currentCalculationSession.calculationInfo.flows[activeFlow][activeConditonIndex ?? 0]?.filter;

  if (!filterName) return null;
  const evaluations =
    currentCalculationSession.calculationInfo.conditionFilters[filterName][0].conditions;

  return (
    <>
      <Divider
        sx={{
          height: '2px',
          backgroundColor: 'rgba(224, 224, 224, 1)',
          border: 'none',
        }}
      />
      <div
        style={{
          minHeight: '4rem',
          padding: '0',
          position: 'relative',
          borderRight: 0,
          paddingTop: '0.5rem',
          // background:'red'
          minWidth: '14rem',
          maxHeight: '320px',
          display: 'flex',
          flexDirection: 'column',
          boxSizing: 'border-box',
          scrollbarGutter: ' stable both-edges',
        }}
        className=" hideScrollBar"
      >
        <Typography
          variant="h6"
          align="left"
          sx={{
            paddingInline: '0.5rem',
            fontSize: fontSize.large,
            fontWeight: 600,
            color: 'primary.contrastText',
          }}
        >
          {/* <Tooltip title="This calculation is being used in another flow. Please remove the dependency before deleting.">
          <img
            style={{
              marginRight: '5px',
            }}
            src="/padlock.png"
            alt="padlock"
          />
        </Tooltip> */}
          Evaluations
          <Typography
            component="span"
            sx={{
              textAlign: 'center',
              fontSize: fontSize.small,
              color: '#999999',
              marginLeft: '0.3rem',
            }}
          >
            {evaluations.length} of 4
          </Typography>
        </Typography>
        <EvaluationDropZone
          disabled={disableUpdate || evaluations.length >= 4}
          message={evaluations.length >= 4 ? 'Maximum number of evaluation is reached.' : undefined}
          // addSourceInfoInCalculationFlow={addSourceInfoInCalculationFlow}
        >
          {conditionTypeElse ? (
            <Typography
              variant="h6"
              align="center"
              sx={{
                paddingleft: '0.5rem',
                paddingRight: '0.35rem',
                fontSize: fontSize.medium,
                color: 'primary.contrastText',
              }}
            >
              No Conditions for <b>ELSE</b>
            </Typography>
          ) : (
            evaluations.map((evaluation, index: number) => {
              return (
                <EvaluationCard
                  evaluation={evaluation}
                  evaluationType={evaluation.leftOperandType[0]}
                  propKey={propKey}
                  filterIdx={index}
                  key={evaluation.conditionUID}
                  lastDroppedEvaluationUid={
                    currentCalculationSession.calculationInfo.conditionFilters[filterName][0]
                      .lastDroppedEvaluationUid
                  }
                  conditionFilterId={filterName}
                  disableUpdate={disableUpdate}
                />
              );
            })
          )}
        </EvaluationDropZone>
      </div>
      <Divider
        sx={{
          height: '2px',
          backgroundColor: 'rgba(224, 224, 224, 1)',
          border: 'none',
          margin: '3px 0 3px 0',
        }}
      />
    </>
  );
};

export default Evaluations;
